'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var heroLinks = document.querySelector('.clc-Header_Links');

  heroLinks.addEventListener('scroll', function () {
    var heroLinksArrow = heroLinks.querySelector('.clc-Header_Links-arrow');
    heroLinksArrow.classList.remove('clc-Header_Links-arrowActive');
  });
}